import { useSelector } from 'react-redux';
import _ from 'lodash';
import InputForm from '../InputForm';
import { RootState } from '../../../../../../../state/store';
import formCommonSizeProfitLossTemplate from './formCommonSizeProfitLossTemplate.json';
import {
  getRowTemplate,
  getFormDataFromState,
  getForm,
  updateJson,
  getItemsAndAppend,
} from '../../common/FormUtil';
import { FormGroup, FormType, FormGroupType, FormGroupI } from '../../../../../../../types/inputform.d';

export const generateFormCommonSizeProfitLoss = (
  group: FormGroupType,
  commonSizeProfitLossCells: any,
  dbJson: any,
  loanDetails: any
) => {
  const formCells = _.cloneDeep(commonSizeProfitLossCells);

  let allRows: any[] = [];
  let formDataCells: any;

  if (!_.isEmpty(formCells)) {
    formDataCells = getFormDataFromState(formCells, group);
  } else if (_.isEmpty(formCells)) {
    const { form: formCommonSizeProfitLoss, productsWithSales } = _.cloneDeep(
      formCommonSizeProfitLossTemplate
    ) as any;
    const { products } = loanDetails;

    updateJson(
      'type',
      'productsWithSales',
      getItemsAndAppend(products, productsWithSales, 'product'),
      formCommonSizeProfitLoss
    );

    // Total Rows //
    allRows = getRowTemplate('label', formCommonSizeProfitLoss);

    formDataCells = getForm(
      formCells,
      FormType[FormType.FORMCOMMONSIZEPROFITLOSS].toLowerCase(),
      group,
      allRows,
      dbJson,
      loanDetails
    );
  }

  // if (group === FormGroup.PROJECTION) {
  //   Object.entries(formJson).map(([, cell]) => cell?.expr && cellUpdate(copyCells, cell, cell?.expr));
  // }
  return formDataCells;
};

export const FormCommonSizeProfitLoss = ({ group }: FormGroupI) => {
  const cells = useSelector(
    (state: RootState) => state?.inputscreen?.cells![FormType[FormType.FORMCOMMONSIZEPROFITLOSS].toLowerCase()]
  );

  if (!group || !cells) return <></>;

  const cellData: any = {};

  const actualsCells = Object.fromEntries(
    Object.entries(cells).filter(([, value]: any) => value?.group === FormGroup[FormGroup.ACTUALS].toLowerCase())
  );
  _.merge(cellData, actualsCells);

  if (group === FormGroup.PROJECTION) {
    const projectionCells = Object.fromEntries(
      Object.entries(cells).filter(
        ([, value]: any) => value?.group === FormGroup[FormGroup.PROJECTION].toLowerCase()
      )
    );
    _.merge(cellData, projectionCells);
  }

  return <InputForm cells={cellData} />;
};
